var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input__button",staticStyle:{"background-color":"#06ba77"},on:{"click":_vm.send}},[_vm._v(" Send It! ")])}
var staticRenderFns = []

export { render, staticRenderFns }